import React from 'react';
import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import * as actions from '../User/store/userActions';
import ChangePasswordForm from './ChangePasswordForm'
import * as Yup from "yup";

const styles = theme => ({
    root: {
        width: `50%`,
        height: 'auto',
        paddingTop: theme.spacing(),
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
});

const ChangePassword = props => {
    const { classes, userID, translations, passwordComplexity, activeCustomer, onChangePassword } = props;

    const submitHandler = async data => {
        delete data['RepeatPassword']
        let response = await onChangePassword({ ...data, ActiveCustomerID: activeCustomer, UserID: userID, PasswordComplexity: passwordComplexity });
        if (response) {
            localStorage.removeItem("CORE|AUTH|PASSWORD|EXPIRED");
            window.location = '/login';
        }
    }

    let initialValues = {
        Password: "",
        RepeatPassword: ""
    };
    let formSettings = {
        Validation: {
            NewPassword: Yup.string().required("Required"),
            RepeatPassword: Yup.string()
                .oneOf([Yup.ref("NewPassword"), null], "Passwords must match")
                .required("Required"),
        },
        FormTitle: translations["change_password"] || "Change password",
        ButtonSubmit: {
            Title: translations["save"] || "SAVE"
        }
    };

    return (
        <ChangePasswordForm
            classes={classes}
            formSettings={formSettings}
            initialValues={initialValues}
            handleSubmit={submitHandler}
            translations={translations}
            passwordComplexity={passwordComplexity}
        />
    )
}

const mapStateToProps = state => {
    return {
        activeCustomer: state.core.login.activeCustomer && state.core.login.activeCustomer.CustomerID ? state.core.login.activeCustomer.CustomerID : null,
        passwordComplexity: state.core.login && state.core.login.passwordComplexity ? state.core.login.passwordComplexity : 'securaze_standard',
        UserID: state.core.login.user && state.core.login.user.UserID ? state.core.login.user.UserID : null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onChangePassword: (data) => dispatch(actions.changePassword(data)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ChangePassword));
